import { styled } from 'styled-components'
import COLORS from '@web-ui-kit/colors'

export const Container = styled.div`
  white-space: nowrap;
  width: 100%;
  & > button:hover {
    background-color: transparent;
  }
`

export const Divider = styled.div`
  background-color: ${COLORS.NEUTRAL_200};
  height: 0.0625rem;
  width: 100%;
`
